import { render, staticRenderFns } from "./Forest.vue?vue&type=template&id=7fd464b9&scoped=true&"
import script from "./Forest.vue?vue&type=script&lang=js&"
export * from "./Forest.vue?vue&type=script&lang=js&"
import style0 from "./Forest.vue?vue&type=style&index=0&id=7fd464b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd464b9",
  null
  
)

export default component.exports